import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { powerStripPowers } from "../../common/deviceStatePowerKey";
import { panelDetailSelector } from "../../store/panel/detail";
import { DeviceDetailType } from "../../api/devices/device";
import { Button, Switch } from "antd";
import { fetchDeviceControl } from "../../store/panel/control";
import { AppDispatch } from "../../store";

const PowerStripPanel = ({
  action,
  token,
}: {
  action: any;
  token?: string;
}) => {
  const { detail } = useSelector(panelDetailSelector);
  const { id, status, deviceName, spaceName } = detail as DeviceDetailType;
  const dispatch = useDispatch<AppDispatch>();

  const handleIndividualPower = useCallback(
    (key: powerStripPowers) => () => {
      if (id && status)
        dispatch(
          fetchDeviceControl({
            id,
            token,
            body: { [key]: !status[key] },
          })
        );
    },
    [dispatch, id, status]
  );

  const handleMainPower = useCallback(
    (power: boolean) => () => {
      if (id && status)
        dispatch(
          fetchDeviceControl({
            id,
            token,
            body: { power5: power },
          })
        );
    },
    [dispatch, id, status]
  );

  const setSwitch = (powerNum: number) => {
    return (
      <div
        className={`switch-item ${
          status && status[`power${powerNum as 1 | 2 | 3 | 4 | 5}`] && "on"
        }`}
      >
        <div className="control-header">
          {powerNum === 4 ? (
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_3472_139420)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M12 6C11.4477 6 11 6.44772 11 7C11 7.55228 11.4477 8 12 8C12.5523 8 13 7.55228 13 7C13 6.44772 12.5523 6 12 6ZM9.17071 6C9.58254 4.83481 10.6938 4 12 4C13.6569 4 15 5.34315 15 7C15 8.65685 13.6569 10 12 10C10.6938 10 9.58254 9.16519 9.17071 8H8.5C7.67157 8 7 8.67157 7 9.5V10C7 10.3506 6.93985 10.6872 6.82929 11H18V9C18 8.62123 18.214 8.27496 18.5528 8.10557C18.8916 7.93618 19.297 7.97274 19.6 8.2L23.6 11.2C23.8518 11.3889 24 11.6852 24 12C24 12.3148 23.8518 12.6111 23.6 12.8L19.6 15.8C19.297 16.0273 18.8916 16.0638 18.5528 15.8944C18.214 15.725 18 15.3788 18 15V13H8.94999C8.98279 13.1616 9 13.3288 9 13.5V14.5C9 15.3284 9.67157 16 10.5 16H11V15C11 14.4477 11.4477 14 12 14H16C16.5523 14 17 14.4477 17 15V19C17 19.5523 16.5523 20 16 20H12C11.4477 20 11 19.5523 11 19V18H10.5C8.567 18 7 16.433 7 14.5V13.5C7 13.2239 6.77614 13 6.5 13H0V11H4C4.55228 11 5 10.5523 5 10V9.5C5 7.567 6.567 6 8.5 6H9.17071ZM13 16V18H15V16H13ZM20 11V13L21.3333 12L20 11Z"
                  fill="#989691"
                />
              </g>
              <defs>
                <clipPath id="clip0_3472_139420">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          ) : (
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_3472_139401)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.5556 1H12.4444C14.087 0.999993 15.3809 0.999988 16.4222 1.08507C17.4846 1.17186 18.3717 1.35217 19.1779 1.76295C20.4951 2.43407 21.5659 3.50493 22.237 4.82207C22.6478 5.62827 22.8281 6.51543 22.9149 7.57778C23 8.61909 23 9.91303 23 11.5556L23 15.0875C23.0001 15.9329 23.0001 16.4579 22.9401 16.9137C22.5266 20.0548 20.0548 22.5266 16.9137 22.9401C16.4579 23.0001 15.9329 23.0001 15.0875 23L15 23V21C15.9606 21 16.3441 20.9978 16.6526 20.9572C18.8963 20.6618 20.6618 18.8963 20.9572 16.6526C20.9978 16.3441 21 15.9606 21 15V11.6C21 9.90334 20.9992 8.69099 20.9216 7.74064C20.8449 6.80197 20.6982 6.20732 20.455 5.73005C19.9757 4.78924 19.2108 4.02433 18.27 3.54497C17.7927 3.30179 17.198 3.15512 16.2594 3.07842C15.309 3.00078 14.0967 3 12.4 3H11.6C9.90335 3 8.69099 3.00078 7.74065 3.07842C6.80198 3.15512 6.20732 3.30179 5.73005 3.54497C4.78924 4.02433 4.02434 4.78924 3.54497 5.73005C3.30179 6.20732 3.15512 6.80197 3.07843 7.74064C3.00078 8.69099 3 9.90334 3 11.6V15.3333C3 15.9736 3.00096 16.2293 3.01903 16.4358C3.23051 18.853 5.14699 20.7695 7.56423 20.981C7.77074 20.999 8.02644 21 8.66667 21C8.99736 21 9.09829 20.999 9.17432 20.9924C10.1412 20.9078 10.9078 20.1412 10.9924 19.1743C10.996 19.1335 10.9979 19.0854 10.9989 18.9984C10.5239 18.9951 10.1087 18.9853 9.74818 18.9558C9.18608 18.9099 8.66938 18.8113 8.18404 18.564C7.43139 18.1805 6.81947 17.5686 6.43598 16.816C6.18869 16.3306 6.09012 15.8139 6.0442 15.2518C5.99998 14.7106 5.99999 14.0463 6 13.2413L6 10C6 9.44772 6.44772 9 7 9H8V5H10V9H14V5H16V9H17C17.5523 9 18 9.44772 18 10V13.2413C18 14.0463 18 14.7106 17.9558 15.2518C17.9099 15.8139 17.8113 16.3306 17.564 16.816C17.1805 17.5686 16.5686 18.1805 15.816 18.564C15.3306 18.8113 14.8139 18.9099 14.2518 18.9558C13.8908 18.9853 13.4749 18.9951 12.9991 18.9984C12.9977 19.1298 12.994 19.2431 12.9848 19.3486C12.8156 21.2824 11.2824 22.8156 9.34863 22.9848C9.17363 23.0001 8.97744 23.0001 8.71252 23H8.60838C8.04485 23 7.69496 23.0001 7.38991 22.9734C4.00579 22.6773 1.32271 19.9942 1.02664 16.6101C0.999953 16.305 0.999972 15.9552 1 15.3916L1 11.5556C0.999997 9.91304 0.999992 8.61909 1.08507 7.57778C1.17187 6.51543 1.35218 5.62827 1.76296 4.82207C2.43407 3.50493 3.50494 2.43407 4.82207 1.76295C5.62827 1.35217 6.51543 1.17186 7.57778 1.08507C8.6191 0.999988 9.91305 0.999993 11.5556 1ZM16 11H8V13.2C8 14.0566 8.00078 14.6389 8.03756 15.089C8.07338 15.5274 8.1383 15.7516 8.21799 15.908C8.40974 16.2843 8.7157 16.5903 9.09202 16.782C9.24842 16.8617 9.47263 16.9266 9.91104 16.9624C10.3611 16.9992 10.9434 17 11.8 17H12.2C13.0566 17 13.6389 16.9992 14.089 16.9624C14.5274 16.9266 14.7516 16.8617 14.908 16.782C15.2843 16.5903 15.5903 16.2843 15.782 15.908C15.8617 15.7516 15.9266 15.5274 15.9625 15.089C15.9992 14.6389 16 14.0566 16 13.2V11Z"
                  fill="#989691"
                />
              </g>
              <defs>
                <clipPath id="clip0_3472_139401">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          )}

          <h1>{powerNum === 4 ? "USB 포트" : `${powerNum}구`}</h1>
        </div>
        <Switch
          size="default"
          key={powerNum}
          onChange={handleIndividualPower(
            `power${powerNum as 1 | 2 | 3 | 4 | 5}`
          )}
          checked={status && status[`power${powerNum as 1 | 2 | 3 | 4 | 5}`]}
        />
      </div>
    );
  };

  return (
    <section className="device-setting-body">
      <div className="device-setting-top">
        <h1>{deviceName}</h1>
        <div className="device-setting-header">
          <div className="remain-battery">
            <p>{spaceName ? spaceName : "미지정"}</p>
          </div>
        </div>
      </div>
      {status && (
        <div className="device-display powerstrip">
          <h2>개별 제어</h2>
          <div className="display switch-container">
            <>
              {[...Array(4)].map((n, index) => {
                return setSwitch(index + 1);
              })}
            </>
          </div>
        </div>
      )}
      <div className="device-control-wrap">
        <div className="device-control device-control-flex">
          <Button onClick={handleMainPower(true)} className="switch-button">
            <img
              src={`${process.env.REACT_APP_S3_URL}/1.0/button-icons/power_all_on_icon.png`}
              alt="power_all_on"
            />
            <span>모두 켜기</span>
          </Button>
          <Button onClick={handleMainPower(false)} className="switch-button">
            <img
              src={`${process.env.REACT_APP_S3_URL}/1.0/button-icons/power_all_off_icon.png`}
              alt="power_all_off"
            />
            <span>모두 끄기</span>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default PowerStripPanel;
